import { Link } from 'gatsby'
import React, { useState } from 'react'
import styled from 'styled-components'
import StudentGrid from './StudentGrid'

const MenuIcon = styled.button`
  border: 0.1em solid ${({ nav }) => (nav ? 'var(--light)' : 'var(--black)')};
  color: ${({ nav }) => (nav ? 'var(--light)' : 'var(--black)')};
  margin: 20px auto;
  font-family: var(--sans);
  background: var(--light);
  /* font-variation-settings: 'wght' 500; */
  background: none;
  font-weight: 500;
  font-size: var(--medium-text);
  padding: 0.5em 1em;
  border-radius: 2em;
  outline: none;
  position:fixed;
  top:0;
  right:0.5em;
  z-index:200;
  transition: border 0.3s cubic-bezier(0.28, 0.76, 0.41, 1), transform 0.3s cubic-bezier(0.28, 0.76, 0.41, 1);
  margin-top:1em;
  :focus {
    outline: none;
    border-radius: 5px;
    box-shadow: 0px 0px 30px rgba(0, 0, 0.2);
  }

  :active {
    transform: scale(0.8);
  }

  div {
    width: 1.75rem;
    height: 0.125rem;
    background: var(--text-color);
    border-radius: 5px;
    transform-origin: 0.2rem;
    position: relative;

    transition: opacity 100ms, transform 0.3s cubic-bezier(0.28, 0.76, 0.41, 1);
    :first-child {
      transform: ${({ nav }) => (nav ? 'rotate(45deg)' : 'rotate(0deg)')};
    }

    :nth-child(2) {
      opacity: ${({ nav }) => (nav ? '0' : '1')};
    }

    :nth-child(3) {
      transform: ${({ nav }) => (nav ? 'rotate(-45deg)' : 'rotate(0deg)')};
    }
  }
`

const NavStyles = styled.nav`
  ul {
    list-style-type: none;
    font-size: 10vw;
    padding: 0;
    width: 100%;
  }
`

const ItemStyle = styled.li`
  li {
    width: 100%;
  }

  a {
    display: block;
    text-decoration: none;
    transition: transform 1s ease-in-out, opacity 2s ease-in-out;

    transform: ${({ nav }) => (nav ? 'translateX(0%)' : 'translateX(20%)')};
    opacity: ${({ nav }) => (nav ? '1.0' : '0.0')};
    :hover {
      background: var(--text-color);
      color: var(--bg-color);
    }
  }

  &:nth-child(2) {
    a {
      transition-delay: 0.2s;
    }
  }

  &:nth-child(3) {
    a {
      transition-delay: 0.125s;
    }
  }

  &:nth-child(4) {
    a {
      transition-delay: 0.25s;
    }
  }
  &:nth-child(3) {
    a {
      transition-delay: 0.125s;
    }
  }

  &:nth-child(5) {
    a {
      transition-delay: 0.3s;
    }
  }
`

const MenuLinks = styled.div`
  z-index: 100;

  /* font-size: 2em; */
  /* display: flex; */
  /* flex-direction: column; */
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100vh;
  width: 100%;
  background: var(--black);
  position: fixed;
  overflow-y: scroll;
  top: 0;
  right: 0;
  transform: ${({ nav }) => (nav ? 'translateX(0%)' : 'translateX(100%)')};
  transition: transform 0.75s cubic-bezier(0.28, 0.76, 0.41, 1);
  /* padding-top:5em; */
  /* padding-bottom:20vh; */
`

export default function Nav ({ students }) {
  const [nav, showNav] = useState(false)
  return (
    <NavStyles>
      <MenuIcon
        nav={nav}
        onClick={() => showNav(!nav, console.log(nav))}
      >Artists</MenuIcon>
      <MenuLinks nav={nav} onClick={() => showNav(!nav, console.log(nav))}>

        <StudentGrid students={students}></StudentGrid>
        {/* <ItemStyle nav={nav}>
            <Link to="/">Home</Link>
          </ItemStyle>
          <ItemStyle nav={nav}>
            <Link to="/students">Artists</Link>
          </ItemStyle> */}
      </MenuLinks>
    </NavStyles>
  )
}
